import React from 'react';


const ErrorReport=({display})=>{
    if(!display) return ""
	return(
		<div className="report-box justify-content-center" id="error-report">
            <div className="report-box-header red">
                <span className="glyphicon glyphicon-alert fa-fw"> </span>
                THIS REPORT IS NOT READY YET
            </div>
            <div className="report-box-text">
                We couldn't find a complete assessment for this project or branch our servers.
                <ul>
                    <li>If you just started monitoring this project that's perfectly normal as we might need a
                        few minutes to create the first assessment
                    </li>
                    <li>Similarly, if you just accessed this branch for the first time, we need to complete a
                        first scan before showing the results and it might take
                        a few more minutes
                    </li>
                </ul>
                If the problem persists or you believe there's a problem, please contact <a
                    href="mailto:support@meterian.com">Meterian support</a> and we'll have a look for you.
            </div>
        </div>
	)
}

const Unsupported=({display})=>{

    if(!display) return ""
	return(
		<div className="report-box justify-content-center" id="unsupported-project">
            <div className="report-box-header red">
                <span className="glyphicon glyphicon-alert fa-fw"> </span>
                THIS PROJECT IS NOT SUPPORTED
            </div>
            <div className="report-box-text">
                At the moment we support Java(TM) projects build using Apache Maven or Gradle,
                Javascript web based projects or NodeJS projects.<br/>
                Meterian looks for the required files in the root folder (and subfolders) of the project
                to start its analysis; since we could not locate such files, we couldn't build a report.<br/>
                Please contact <a href="mailto:support@meterian.com">Meterian support</a> if you have any
                further question.
            </div>
        </div>
	)
}

const Failure=({display})=>{

    if(!display) return ""
	return(
		<div className="report-box justify-content-center" id="failure-project">
            <div className="report-box-header red">
                <span className="glyphicon glyphicon-alert fa-fw"> </span>
                WE COULDN'T BUILD A REPORT
            </div>
            <div className="report-box-text">
                Our reporting engine could not create a report for this project <br/>
                Often the problem is that the project doesn't build, possibly for a issue in the build itself or
                because the build relies on some other tool to complete.<br/>
                Please contact <a href="mailto:support@meterian.com">Meterian support</a> if you have any
                further question.
            </div>
        </div>
	)
}
const ProjectNotFound=({display})=>{

    if(!display) return ""
	return(
		<div className="report-section default d-flex justify-content-center pt-5" id="error-project">
		    <div className="container">

		        <div className="row only-first">
		            <div className="report-box">
		                <div className="report-box-header red">
		                    <span className="glyphicon glyphicon-alert fa-fw"> </span>
		                    SORRY, WE COULDN'T FIND THE PROJECT
		                </div>
		                <div className="report-box-text">
		                    You tried to access a project report that doesn't exist or that is not accessible to you.<br/>
		                    Please check the URL you entered - in case you still think you should be able to access this page,
		                    please contact <a href="mailto:support@meterian.com">Meterian support</a>.
		                </div>
		            </div>
		        </div>
		    </div>
		</div>
	)
}
const ExceptionBox=()=>{
	return(
		<div className="report-section default d-flex justify-content-center pt-5" id="error-project">
		    <div className="container">

		        <div className="row only-first">
		            <div className="report-box">
		                <div className="report-box-header red">
		                    <span className="glyphicon glyphicon-alert fa-fw"> </span>
		                    SORRY, SOMETHING WENT WRONG
		                </div>
		                <div className="report-box-text">
		                    Something went wrong while trying to access this report.
                            This is likely an issue with the application. <br /><br />
                            Please contact <a href="mailto:support@meterian.com">Meterian support</a>.
		                </div>
		            </div>
		        </div>
		    </div>
		</div>
	)
}
export {ErrorReport, Unsupported, Failure, ProjectNotFound, ExceptionBox};